import { Col, Row } from "react-bootstrap";
import Newlogin from "../../LoginLayout/NewLogin";
import './index.scss'

export default function Home() {
  return (
    <div className="Home d-flex flex-column align-items-center justify-content-center  ">
      <Row>
        <Col xs={12} md={6} lg={4}>
          <Newlogin />
        </Col>
      </Row>
    </div>
  );
}
